 //lightbox script
  document.addEventListener('DOMContentLoaded', function () {
  const lightbox = document.querySelector('#ccLightbox');
  const lightboxImage = lightbox.querySelector('img');
  const closeButton = lightbox.querySelector('.cc-lightbox-close');

  document.querySelectorAll('.cc-lightbox-trigger').forEach((link) => {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      lightboxImage.src = this.href;
      lightbox.classList.add('is-open');
    });
  });
  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightboxImage.src = '';
  }
  closeButton.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', function (event) {
    if (event.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });
});